<template>
  <el-dialog :visible.sync="visible" width="min(640px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="invoicePurchaseRed" :biz-id="form.id" perm="finance:invoicePurchaseRed" :approve-status="String(form.approveStatus || '0')" @approve="approve(form, true)" @unapprove="approve(form, false)" />
            <el-button v-if="isAuth('finance:invoicePurchaseRed:update') || isAuth('finance:invoicePurchaseRed:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:invoicePurchaseRed:delete') || isAuth('finance:invoicePurchaseRed:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : formRules" :disabled="readonly" label-width="110px">
      <el-form-item label="内部单号" prop="code"><el-input v-model="form.code" :disabled="codeReadonly || !!form.id" :placeholder="codeReadonly ? '保存时自动生成' : ''" /></el-form-item>
      <el-form-item label="红字发票号码"><el-input v-model.trim="form.taxInvoiceNumber" maxlength="64" :placeholder="readonly ? '' : '实际红字票据号码，未取得可留空'" /></el-form-item>
      <el-form-item label="发票日期" prop="bizDate">
        <el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
      </el-form-item>
      <el-form-item label="供应商" prop="supplierId">
        <el-input :value="form.partnerName" readonly placeholder="请选择供应商">
          <el-button v-if="!readonly" slot="append" @click="picker = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="原进项发票" prop="sourceId">
        <el-select v-model="form.sourceId" filterable style="width:100%" @change="onSourceChange">
          <el-option v-for="item in sources" :key="item.id"
            :label="(item.code || '') + ' / 可红冲 ' + money(item.remainingRedAmount)" :value="item.id" />
        </el-select>
        <div class="form-tip">已开票退货使用进项红字发票；未开票退货使用采购退货结算。同一笔退货不要重复办理。</div>
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input-number v-model="form.amount" :min="0" :max="currentSource ? Number(currentSource.remainingRedAmount || 0) : Infinity" :precision="2" style="width:100%" />
        <div v-if="currentSource" class="form-tip">原发票剩余可红冲：{{ money(currentSource.remainingRedAmount) }}</div>
      </el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
    <SupplierSelector :visible.sync="picker" @select="onPick" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import SupplierSelector from '../../components/SupplierSelector.vue'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'InvoicePurchaseRedAddOrUpdate',
  mixins: [auth],
  components: { WorkflowDocButtons, SupplierSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      codeReadonly: false,
      picker: false,
      sources: [],
      form: this.blank(),
      rules: {
        code: [{ required: true, message: '内部单号不能为空', trigger: 'blur' }],
        bizDate: [{ required: true, message: '发票日期不能为空', trigger: 'change' }],
        supplierId: [{ required: true, message: '供应商不能为空', trigger: 'change' }],
        sourceId: [{ required: true, message: '原进项发票不能为空', trigger: 'change' }],
        amount: [{ required: true, message: '金额不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formRules() {
      return this.codeReadonly ? { ...this.rules, code: [] } : this.rules
    },
    dialogTitle() {
      if (this.readonly) return '查看进项红字发票'
      return this.form.id ? '修改进项红字发票' : '新增进项红字发票'
    },
    currentSource() {
      return this.sources.find(item => item.id === this.form.sourceId)
    }
  },
  methods: {
    onSourceChange() {
      if (this.currentSource && Number(this.form.amount || 0) > Number(this.currentSource.remainingRedAmount || 0)) {
        this.form.amount = Number(this.currentSource.remainingRedAmount || 0)
      }
    },
    blank() {
      return { kind: 'invoicePurchaseRed', code: '', taxInvoiceNumber: '', bizDate: this.today(), supplierId: '', partnerName: '', sourceId: '', amount: 0, remark: '' }
    },
    loadSources() {
      request.get('/finance/doc/approvedBlueSources', {
        params: {
          kind: 'invoicePurchaseRed',
          partnerId: this.form.supplierId || '',
          includeSourceId: this.form.sourceId || '',
          excludeId: this.form.id || ''
        }
      }).then(res => { this.sources = res.data || [] }).catch(() => { this.sources = [] })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'invoicePurchaseRed' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.code = data.previewCode
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate('code'))
      }).catch(() => {})
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.picker = false
      if (!id) {
        this.form = this.blank()
        this.resolveCode()
        this.loadSources()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/doc/info', { params: { kind: 'invoicePurchaseRed', id } }).then(res => {
        const row = res.data || {}
        this.form = Object.assign({ kind: 'invoicePurchaseRed', lines: [] }, row)
        if (!Array.isArray(this.form.lines)) this.form.lines = []
        this.loadSources()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
    },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (!this.assertCanEditDoc('delete')) return
      this.$confirm('确定删除该进项红字发票?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/doc/delete', { kind: 'invoicePurchaseRed', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    onPick(row) {
      this.form.supplierId = row.supplierId
      this.form.partnerName = row.supplierName
      this.form.sourceId = ''
      this.loadSources()
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/finance/doc/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    approve(row, pass) {
      const url = pass ? '/finance/doc/approve' : '/finance/doc/unapprove'
      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(url, { kind: 'invoicePurchaseRed', id: row.id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          if (row && this.form && ((row.id && this.form.id === row.id) || (row.voucherId && this.form.voucherId === row.voucherId))) {
            this.$set(this.form, 'approveStatus', pass ? '2' : '0')
            this.readonly = true
          }
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.form-tip { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.5; }
</style>
